import axios from "axios";

class MerchantDetails {
  getSummery(token) {
    return axios.get(
      `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/summary?token=${token}`
    );
  }

  tokenSummary(token,refs){
    return axios.get(
      `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/token-summary?token=${token}&refs=${refs}`
    );
  }
}


export default new MerchantDetails();
